import PropTypes from 'prop-types';
import React from 'react';
import { formatPrice } from '../../../helpers/currency';

const VipPreButtonMessage = ({
  currencySymbol,
  discount,
  months,
  vipOneYearCost,
}) => {
  const displayDiscount = formatPrice(discount, true);
  if (typeof discount !== 'number' || typeof vipOneYearCost !== 'number')
    return null;
  const isOneYearMessage = discount > vipOneYearCost;
  const monthOrMonths = months === 1 ? 'MONTH' : 'MONTHS';

  return (
    <>
      {isOneYearMessage && <>Enjoy a YEAR of</>}{' '}
      {!isOneYearMessage && (
        <>
          Enjoy {months} {monthOrMonths} of
        </>
      )}{' '}
      <span className="primary">VIP MEMBERSHIP</span>
      <br /> and receive a discount of{' '}
      <span className="primary">
        {currencySymbol}
        {displayDiscount}
      </span>
    </>
  );
};

VipPreButtonMessage.propTypes = {
  currencySymbol: PropTypes.string,
  discount: PropTypes.number,
  months: PropTypes.number,
  vipOneYearCost: PropTypes.number,
};

export default VipPreButtonMessage;
